import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

interface NavbarProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}

const navLinks = [
  { label: 'Home', page: 'home' },
  { label: 'Articles', page: 'articles' },
  { label: 'Charts', page: 'charts' },
  { label: 'On-Chain', page: 'onchain' },
  { label: 'Newsletter', page: 'newsletter' },
  { label: 'About', page: 'about' },
  { label: 'Contact', page: 'contact' },
];

const Navbar: React.FC<NavbarProps> = ({ currentPage, onNavigate }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-[#0A0A0A]/90 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <button
            onClick={() => onNavigate('home')}
            className="flex items-center gap-2 hover:opacity-90 transition-opacity"
          >
            <div className="w-8 h-8 rounded-full bg-[#F7931A] flex items-center justify-center">
              <span className="text-black font-black text-sm">₿</span>
            </div>
            <div className="flex items-baseline gap-1">
              <span className="font-bold text-white text-lg tracking-tight">UTXO</span>
              <span
                className="font-semibold text-[#F7931A] text-xs tracking-widest uppercase"
                style={{ fontVariant: 'small-caps' }}
              >
                MACRO
              </span>
            </div>
          </button>

          {/* Center Nav — desktop */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <button
                key={link.page}
                onClick={() => onNavigate(link.page)}
                className={`text-sm transition-colors ${
                  currentPage === link.page
                    ? 'text-white font-medium'
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Right — Subscribe button */}
          <div className="hidden md:block">
            <button
              onClick={() => onNavigate('newsletter')}
              className="bg-[#F7931A] text-black font-semibold text-sm px-4 py-2 rounded-lg hover:bg-[#e8871a] transition-colors"
            >
              Subscribe
            </button>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden text-gray-400 hover:text-white transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#0D0D0D] border-t border-white/5 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <button
              key={link.page}
              onClick={() => { onNavigate(link.page); setMobileOpen(false); }}
              className={`text-sm text-left transition-colors ${
                currentPage === link.page ? 'text-white font-medium' : 'text-gray-400 hover:text-white'
              }`}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => { onNavigate('newsletter'); setMobileOpen(false); }}
            className="bg-[#F7931A] text-black font-semibold text-sm px-4 py-2 rounded-lg hover:bg-[#e8871a] transition-colors text-center mt-2"
          >
            Subscribe
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
